import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { App, Button, Drawer, Form, Input, Space, Table, Tag, Typography } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, apiError } from '@/lib/api';
import { useAuthStore } from '@/lib/auth-store';
export function BlocksPage() {
    const { message } = App.useApp();
    const qc = useQueryClient();
    const hasPerm = useAuthStore((s) => s.hasPerm);
    const [drawer, setDrawer] = useState({ open: false });
    const [form] = Form.useForm();
    const q = useQuery({
        queryKey: ['makam-blocks'],
        queryFn: async () => (await api.get('/makam/blocks')).data,
    });
    const createMut = useMutation({
        mutationFn: async (v) => (await api.post('/makam/blocks', v)).data,
        onSuccess: () => {
            message.success('Blok ditambahkan');
            qc.invalidateQueries({ queryKey: ['makam-blocks'] });
            setDrawer({ open: false });
        },
        onError: (e) => message.error(apiError(e)),
    });
    const patchMut = useMutation({
        mutationFn: async ({ id, body }) => (await api.patch(`/makam/blocks/${id}`, body)).data,
        onSuccess: () => {
            message.success('Blok diperbarui');
            qc.invalidateQueries({ queryKey: ['makam-blocks'] });
            setDrawer({ open: false });
        },
        onError: (e) => message.error(apiError(e)),
    });
    const cols = [
        { title: 'Kode', dataIndex: 'code', width: 120 },
        { title: 'Nama', dataIndex: 'name' },
        { title: 'Deskripsi', dataIndex: 'description' },
        {
            title: 'Petak',
            dataIndex: 'plot_count',
            width: 100,
            render: (n) => _jsxs(Tag, { color: "blue", children: [n, " petak"] }),
        },
        {
            title: 'Aksi',
            width: 90,
            render: (_, r) => hasPerm('makam.plot:edit') && (_jsx(Button, { size: "small", icon: _jsx(EditOutlined, {}), onClick: () => {
                    setDrawer({ open: true, row: r });
                    form.setFieldsValue(r);
                } })),
        },
    ];
    return (_jsxs("div", { children: [_jsxs(Space, { style: { marginBottom: 16, display: 'flex', justifyContent: 'space-between' }, children: [_jsx(Typography.Title, { level: 3, style: { margin: 0 }, children: "Blok Makam" }), hasPerm('makam.plot:create') && (_jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), onClick: () => { form.resetFields(); setDrawer({ open: true }); }, children: "Tambah Blok" }))] }), _jsx(Table, { rowKey: "id", loading: q.isLoading, dataSource: q.data ?? [], columns: cols, pagination: { pageSize: 20 }, size: "middle" }), _jsx(Drawer, { open: drawer.open, onClose: () => setDrawer({ open: false }), title: drawer.row ? `Edit Blok ${drawer.row.code}` : 'Tambah Blok', width: 480, destroyOnClose: true, extra: _jsx(Button, { type: "primary", loading: createMut.isPending || patchMut.isPending, onClick: () => form.validateFields().then((v) => {
                        if (drawer.row)
                            patchMut.mutate({ id: drawer.row.id, body: v });
                        else
                            createMut.mutate(v);
                    }), children: "Simpan" }), children: _jsxs(Form, { form: form, layout: "vertical", preserve: false, children: [_jsx(Form.Item, { name: "code", label: "Kode", rules: [{ required: true }], children: _jsx(Input, { placeholder: "mis. A", disabled: !!drawer.row }) }), _jsx(Form.Item, { name: "name", label: "Nama", rules: [{ required: true }], children: _jsx(Input, {}) }), _jsx(Form.Item, { name: "description", label: "Deskripsi", children: _jsx(Input.TextArea, { rows: 3 }) })] }) })] }));
}
